export const CHECKOUT = 'CHECKOUT';

export const TOGGLE_REGISTRATION_FORM = 'TOGGLE_REGISTRATION_FORM';

export const PROCEED_TO_CHECKOUT_AFTER_AUTH = 'PROCEED_TO_CHECKOUT_AFTER_AUTH';

export const SWITCH_REGISTRATION_FORM_STATE = 'SWITCH_REGISTRATION_FORM_STATE';

export const PAYMENT = 'PAYMENT';
export const SUBSCRIPTION = 'SUBSCRIPTION';

export const TOKEN_ERROR_1 = 'user_token required';
export const TOKEN_ERROR_2 = 'unknown user_token';
export const TOKEN_ERROR_3 = 'unknown payment_page_token';
export const TOKEN_ERROR_LIST = [TOKEN_ERROR_1, TOKEN_ERROR_2, TOKEN_ERROR_3]

